import { render } from "./OrderPayment.vue?vue&type=template&id=1f79e8af&scoped=true"
import script from "./OrderPayment.vue?vue&type=script&lang=js"
export * from "./OrderPayment.vue?vue&type=script&lang=js"

import "./OrderPayment.vue?vue&type=style&index=0&id=1f79e8af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f79e8af"]])

export default __exports__